var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon add-icon",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a.5.5 0 01.5.5v7h7a.5.5 0 110 1h-7v7a.5.5 0 11-1 0v-7h-7a.5.5 0 010-1h7v-7A.5.5 0 018 0z"
  })));
}

export default SvgAddIconSv;